export type ViewerAdapterErrorCode =
  | 'forbidden'
  | 'not-found'
  | 'validation'
  | 'conflict'
  | 'expired-asset-url'
  | 'unsupported'
  | 'network'
  | 'unknown';

export interface ViewerAdapterErrorOptions {
  code: ViewerAdapterErrorCode;
  status?: number;
  retryable?: boolean;
  originalError?: unknown;
}

export class ViewerAdapterError extends Error {
  readonly code: ViewerAdapterErrorCode;
  readonly status?: number;
  readonly retryable: boolean;
  readonly originalError?: unknown;

  constructor(message: string, options: ViewerAdapterErrorOptions) {
    super(message);
    this.name = 'ViewerAdapterError';
    this.code = options.code;
    this.status = options.status;
    this.retryable = options.retryable ?? false;
    this.originalError = options.originalError;
  }
}
